export const cacheKey = "/app_settings/territories_data/:id/members" as const;
